import { BaseModel } from './base';
export class KpiType extends BaseModel {
  name: string;
  subscriberId: string;
  siteId: string;
}
